import { create } from "zustand";
import apiRequest from "./apiRequest";

export const useNotificationStore = create((set) => ({
  number: 0,
  loading: false,
  error: null,
fetch: async () => { set({ loading: true, error: null }); try { const res = await apiRequest("/users/notification"); set({ number: res.data.count || 0, loading: false }); } catch (error) { console.error("Failed to fetch notifications:", error); set({ error: error.message, loading: false }); } },
  decrease: (min = 0) => {
    set((prev) => ({ number: Math.max(prev.number - 1, min) }));
  },
  reset: () => {
    set({ number: 0, error: null });
  },
}));
